export const piPi= Math.PI*2;